// Pure attribution logic — no browser globals, so it is trivially testable.
// Decides what a single page hit contributes to source tracking.

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
]

const hostOf = url => {
  try {
    return url ? new URL(url).host : ""
  } catch (_) {
    return ""
  }
}

// Given the current URL search + document.referrer + our own host, return the
// raw source string this hit represents (utm params + external referrer), and
// the gclid. Returns empty raw when the hit is NOT meaningful — i.e. direct or
// internal navigation — which is what makes "last non-direct" work: an empty
// raw tells the caller to leave the existing stored value untouched.
export const deriveSource = (search, referrer, siteHost) => {
  const params = new URLSearchParams(search || "")
  const utm = UTM_KEYS.map(k => {
    const v = params.get(k)
    return v ? `${k}=${encodeURIComponent(v)}` : ""
  }).filter(Boolean)

  const gclid = params.get("gclid") || ""
  const refHost = hostOf(referrer)
  const externalRef = !!refHost && refHost !== siteHost
  const hasUtm = utm.length > 0

  if (!hasUtm && !gclid && !externalRef) {
    return { raw: "", gclid: "" }
  }

  const parts = [...utm]
  if (gclid && !hasUtm) parts.push(`gclid=${gclid}`)
  if (externalRef) parts.push(`referrer=${refHost}`)
  return { raw: parts.join("&"), gclid }
}
